import { AlifPayIcon } from '@icons';

export const Loader = () => {
  return (
    <div className="fixed bottom-0 left-0 right-0 top-0 flex h-screen w-full items-center justify-center bg-white">
      <AlifPayIcon className="animate-bounce" />
    </div>
  );
};
